import styles from './customerTypePriceListPDFPage.module.css'
import { CustomerType } from "../../../state/types"
import { useDataTypesHooks } from '../../../../../features/data-types'
import { PDFHeader } from '../../../../../features/ui'

type Props = {
  pageIndex: number
  customerType: CustomerType
  products: any[]
  pagesAmount: number
}

export const CustomerTypePriceListPDFPage = (props: Props) => {
  const { pageIndex, customerType, products, pagesAmount } = props
  const { formatDateTime, formatPrice } = useDataTypesHooks()

  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <PDFHeader />
        {pageIndex === 0 && (
          <div className={styles.row}>
              <span className={styles.statusTitle}>Lista de Precios: {customerType.name}</span>
              <div className={styles.date}>Fecha: {formatDateTime(new Date())}</div>
          </div>
        )}
          <div className={styles.tableRow}>
            <table className={styles.table}>
              <thead>
                      <tr>
                          <th>Producto</th>
                          <th className={styles.textRight}>Precio</th>
                      </tr>
                  </thead>
                  <tbody>
                      {products.map((item, i) => (
                          item.isHeader ? (
                              <tr key={item.id} className={styles.categoryRow}>
                                  <td colSpan={2} className={styles.categoryCell}>{item.name}</td>
                              </tr>
                          ) : (
                              <tr key={item.id || i}>
                                  <td className={styles.productNameCell}>{item.name}</td>
                                  <td className={styles.textRight}>{formatPrice(item.calculatedPrice)}</td>
                              </tr>
                          )
                      ))}
                  </tbody>
              </table>
          </div>
        <div className={styles.pagination}>
            {pageIndex + 1} / {pagesAmount}
        </div>
        <div className={styles.footer}>
          <div className={styles.legalText}>
            Los precios expresados en este documento están sujetos a modificaciones sin previo aviso. 
            Esta información constituye una referencia para la lista de precios "{customerType.name}" 
            vigente a la fecha de emisión del documento.
          </div>
        </div>
      </div>
    </div>
  )
}
